/* eslint-disable max-classes-per-file */

const AUTH_STATUSES = [401, 403];

export class ClientApiRequestError extends Error {
  constructor(message, status, responseBody) {
    super(message);
    this.name = 'ClientApiRequestError';
    this.status = status;
    this.responseBody = responseBody;
  }
}

// A dag dependency path that resolves to nothing. Rhino validates the request
// body per endpoint, so sending without it would be a 400 anyway; failing here
// names the path instead of leaving a booking to fail downstream.
export class UnresolvedDependencyError extends Error {
  constructor(path) {
    super(`Unresolved strategy dependency: ${path}`);
    this.name = 'UnresolvedDependencyError';
    this.path = path;
  }
}

export const getErrorTypeTag = (error) => {
  if (error?.name === 'UnresolvedDependencyError')
    return 'unresolvedDependency';
  return AUTH_STATUSES.includes(error?.status) ? 'auth' : 'exception';
};
